import ChartLineIcon from './ChartLineIcon'

export default ChartLineIcon
